import { render, staticRenderFns } from "./indexV2.vue?vue&type=template&id=4b27129d&scoped=true"
import script from "./indexV2.vue?vue&type=script&lang=js"
export * from "./indexV2.vue?vue&type=script&lang=js"
import style0 from "./indexV2.vue?vue&type=style&index=0&id=4b27129d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b27129d",
  null
  
)

export default component.exports